import FinalFormField from 'common/components/final-form/FinalFormField';
import { Button, FormCheck, FormGroup } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import { AdvertisingRequest } from './AdvertisingRequest';

interface IAdvertisingForm {
  onSubmit: (values: AdvertisingRequest) => void;
  saving: boolean;
}

function AdvertisingForm(props: IAdvertisingForm) {
  return (
    <Form<AdvertisingRequest> onSubmit={props.onSubmit}>
      {({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <FinalFormField
            label='License Type: *'
            name='licenseType'
            type='select'
            options={[
              { cd: '', descr: '--' },
              { cd: 'VACATION_RENTAL', descr: 'Vacation Rentals' },
              { cd: 'BNB', descr: 'Bed & Breakfast' },
              { cd: 'HOTEL', descr: 'Hotel' },
              {
                cd: 'SHARED_HOUSING_REG',
                descr: 'Shared Housing Registration',
              },
            ]}
          />
          <FinalFormField
            label={
              values.licenseType === 'SHARED_HOUSING_REG'
                ? 'Email: '
                : 'Email: *'
            }
            name='email'
          />

          <Field name='intermediaries' type='checkbox' value='BOOKING'>
            {({ input }) => (
              <FormGroup>
                <FormCheck
                  {...input}
                  id='BOOKING'
                  label='Booking.com'
                  type='checkbox'
                />
              </FormGroup>
            )}
          </Field>
          <Field name='intermediaries' type='checkbox' value='DINA'>
            {({ input }) => (
              <FormGroup>
                <FormCheck
                  {...input}
                  id='DINA'
                  label='DinaCruise.com'
                  type='checkbox'
                />
              </FormGroup>
            )}
          </Field>

          <Button variant='primary' type='submit' disabled={props.saving}>
            Submit
          </Button>
        </form>
      )}
    </Form>
  );
}

export default AdvertisingForm;
